import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';

export function AdminLayoutRoute() {
    return (
        <FrontendLayout frontend="admin">
            <Outlet />
        </FrontendLayout>
    );
}
